import type { HostConfig } from '@/host-config/domain/HostConfig';

export const DEFAULT_HOST_CONFIG: HostConfig = {
  templatesPage: {
    title: 'Template Library',
    subtitle: 'Pre-built templates to kick-start quotes for sellers.',
    emptyTitle: 'No templates yet',
    emptyBody: 'Create your first quote template to help sellers get started faster.',
    newButtonLabel: 'New Template',
    listAriaLabel: 'Template library'
  },
  newTemplateDialog: {
    title: 'New template',
    description: 'Configure name and styling to create a new quote template.'
  },
  templateEditor: {
    backToListLabel: 'Back to Template Library'
  },
  blockLibraryPage: {
    title: 'Block Library',
    subtitle: 'Reusable pieces of a quote document. Edit a block once, use it across many templates.',
    newButtonLabel: 'New Block'
  }
};
